import React from 'react';
import { Link } from 'react-router-dom';

import ContentWithBackButton from 'components/PageLayout/ContentWithBackButton';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';

import styles from './PoliciesPage.module.scss';

const TermsOfUse = () => {
  const onlinePrivacyPolicyLink = (
    <Link to={CuroAppRoute.OnlinePrivacyPolicy} title="Online Privacy Policy" target="_blank">
      Online Privacy Policy{' '}
    </Link>
  );
  const consumerPrivacyNoticeLink = (
    <a href={'/Privacy Notice.pdf'} target="_blank" title="Consumer Privacy Notice">
      Consumer Privacy Notice
    </a>
  );

  const renderContent = () => {
    return (
      <div className={styles.consentContent}>
        <p>
          Welcome to the Website of Heights Finance Corporation and its affiliates (the “Company”,
          “we” or “us”). The following terms and conditions, together with any documents referred to
          in them (collectively, these “Terms of Use”), apply to your use of this website including
          any content, functionality and services offered on or through www.heightsfinance.com (the
          “Website”), whether as a guest or a registered user.
        </p>
        <p>
          Please read the Terms of Use carefully before you start to use the site. By using the
          Website, you accept and agree to be bound and abide by these Terms of Use. If you do not
          want to agree to these Terms of Use, you must not access or use the Website.
        </p>
        <p className={styles.contentSubtitle}>Privacy and Personal Information</p>
        <p>
          All information we collect on this Website is subject to our {onlinePrivacyPolicyLink} and{' '}
          {consumerPrivacyNoticeLink}. By using the Website, you authorize and consent to all
          actions taken by us with respect to your information in compliance with the Policies. You
          represent and warrant that all data provided by you is accurate.
        </p>
        <p className={styles.contentSubtitle}>Intellectual Property Rights</p>
        <p>
          The content on the Website, including without limitation, the text, software, scripts,
          html code, graphics, photos, sounds, music, videos, interactive features and the like
          (“Content”) and the trademarks, service marks, domain names and logos contained therein
          (“Marks”), are owned by or licensed to us, subject to copyright and other intellectual
          property rights under United States and foreign laws and international conventions.
          Content on the Website is provided to you AS IS for your information and personal use only
          and may not be used, copied, reproduced, distributed, transmitted, broadcast, displayed,
          sold, licensed, or otherwise exploited for any other purposes whatsoever without the prior
          written consent of Company or the respective owners. We reserve all rights not expressly
          granted in and to the Website and the Content. You agree to not engage in the use,
          copying, or distribution of any of the Content or the Marks other than expressly permitted
          herein, including any use, copying, or distribution of User Submissions of third parties
          obtained through the Website for any commercial purposes. If you download or print a copy
          of the Content for personal use, you must retain all copyright and other proprietary
          notices contained therein. You agree not to circumvent, disable or otherwise interfere
          with security related features of the Website or features that prevent or restrict use or
          copying of any Content or enforce limitations on use of the Website or the Content
          therein.
        </p>
        <p className={styles.contentSubtitle}>Website Access</p>
        <p>
          The Company hereby grants you permission to use the Website as set forth in this Terms of
          Use, provided that:
          <ul>
            <li>
              Your use of the Website does not in any way violate any applicable federal, state,
              local and international law or regulation (including, without limitation, any laws
              regarding the export of data or software to and from the U.S. or other countries).
            </li>
            <li>
              Your use of the Website does not exploit, harm or attempt to exploit or harm minors in
              any way by exposing them to inappropriate content, asking for personally identifiable
              information or otherwise.
            </li>
            <li>
              Your use of the Website as permitted is solely for your personal, noncommercial use.
            </li>
            <li>
              You will not copy or distribute any part of the Website in any medium without the
              Company’s prior written authorization.
            </li>
            <li>
              You will not alter or modify any part of the Website other than as may be reasonably
              necessary to use the Website for its intended purpose.
            </li>
            <li>You will otherwise comply with the terms and conditions of these Terms of Use.</li>
          </ul>
        </p>
        <p>
          In order to access some features of the Website, you may have to create an account. You
          may never use another’s account without permission. When creating your account, you agree
          to provide accurate, current and complete information. You are solely responsible for the
          activity that occurs on your account, and you must keep your account password secure. You
          must notify the Company immediately of any breach of security or unauthorized use of your
          account. Although the Company will not be liable for your losses caused by any
          unauthorized use of your account, you agree to defend and indemnify the Company or others
          for the losses due to such unauthorized use.
        </p>
        <p>
          Additionally, you agree not to:
          <ul>
            <li>
              Use or launch any automated system, including without limitation, “robots,” “spiders,”
              “offline readers,” etc., that accesses the Website in a manner that sends more request
              messages to the Company’s servers in a given period of time than a human can
              reasonably produce in the same period by using a convention on-line web browser.
              Notwithstanding the foregoing, the Company grants the operators of public search
              engines permission to use spiders to copy materials from the site for the sole purpose
              of creating publicly available searchable indices of the materials, but not caches or
              archives of such materials.
            </li>
            <li>
              Use any manual process to monitor or copy any of the material on the Website or for
              any other unauthorized purpose without our prior written consent.
            </li>
            <li>
              Introduce any viruses, Trojan horses, worms, logic bombs or other material which is
              malicious or technologically harmful.
            </li>
            <li>
              Attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of
              the Website, the server on which the Website is stored, or any server, computer or
              database connected to the Website.
            </li>
            <li>
              Attack the Website via a denial-of-service attack or a distributed denial-of-service
              attack.
            </li>
            <li>
              Impersonate the Company, a company employee, another user or other person or entity.
            </li>
            <li>Otherwise attempt to interfere with the proper working of the Website.</li>
          </ul>{' '}
        </p>
        <p>
          The Company reserves the right to revoke these exceptions either generally or in specific
          cases. You agree not to collect or harvest any personally identifiable information,
          including account names, from the Website, nor to use the communication systems provided
          by the Website for any commercial solicitation purposes. You agree not to solicit, for
          commercial purposes, any users of the Website for any reason without written consent of
          the Company.
        </p>
        <p className={styles.contentSubtitle}>Reliance on Information Posted</p>
        <p>
          The information presented on or through the Website is made available AS IS solely for
          general information purposes. We do not warrant the accuracy, completeness or usefulness
          of this information. Any reliance you place on such information is strictly at your own
          risk. We disclaim all liability and responsibility arising from any reliance placed on
          such materials by you or any other visitor to the Website, or by anyone who may be
          informed of any of its contents.
        </p>
        <p className={styles.contentSubtitle}>Changes to the Website</p>
        <p>
          We may update the Website from time to time, but its content is not necessarily complete
          or up-to-date. Any of the material on the Website may be out of date at any given time,
          and we are under no obligation to update such material. We may change the Website at any
          time with or without notice. We may suspend access to the Website, or close it
          indefinitely.
        </p>
        <p className={styles.contentSubtitle}>Linking to the Website</p>
        <p>
          You may link to our homepage, provided you do so in a way that is fair and legal and does
          not damage our reputation or take advantage of it, but you must not establish a link in
          such a way as to suggest any form of association, approval or endorsement on our part
          where none exists. You must not establish a link from any website that is not owned by
          you. The Website must not be framed on any other site, nor may you create a link to any
          part of the Website other than the homepage. You agree to cooperate with us in causing any
          unauthorized framing or linking immediately to cease. We reserve the right to withdraw
          linking permission without notice.
        </p>

        <p className={styles.contentSubtitle}>Links from the Website</p>
        <p>
          If the Website contains links to other sites and resources provided by third parties,
          these links are provided for your convenience only. This includes links contained in
          advertisements, including banner advertisemencopyts and sponsored links. We have no
          control over the contents of those sites or resources, and accept no responsibility for
          them or for any loss or damage that may arise from your use of them. If you decide to
          access any of the third party websites linked to this Website, you do so entirely at your
          own risk and subject to the terms and conditions of use for such websites.
        </p>
        <p>
          This Website may provide certain social media features that enable you to:
          <ul>
            <li>
              Link from your own or certain third-party websites to certain content on this Website.
            </li>
            <li>
              Send e-mails or other communications with certain content, or links to certain
              content, on this Website.
            </li>
            <li>
              Cause limited portions of content on this Website to be displayed or appear to be
              displayed on your own or certain third-party websites.
            </li>
          </ul>
        </p>
        <p>
          You may use these features solely as they are provided by us and solely with respect to
          the content they are displayed with and otherwise in accordance with any additional terms
          and conditions we provide with respect to such features. Subject to the foregoing, you
          must not:
          <ul>
            <li>Establish a link from any website that is not owned by you.</li>
            <li>
              Cause the Website or portions of it to be displayed, or appear to be displayed by, for
              example, framing, deep linking or in-line linking, on any other site.
            </li>
            <li>Link to any part of the Website other than the homepage.</li>
            <li>
              Otherwise take any action with respect to the materials on this Website that is
              inconsistent with any other provision of these Terms of Use.
            </li>
          </ul>
        </p>
        <p>
          You agree to cooperate with us in causing any unauthorized framing or linking immediately
          to cease. We reserve the right to withdraw linking permission without notice.
        </p>

        <p className={styles.contentSubtitle}>Submission of Ideas</p>
        <p>
          Company policy is to not accept or review unsolicited ideas or suggestions from persons
          outside the company. Notwithstanding that policy, any ideas, suggestions, know-how,
          comments or concepts that are offered or communicated to Company through this website or
          otherwise (“Submitted Materials”) shall be the property of Company, and may be treated by
          Company as non-confidential even if labeled confidential or proprietary. Company shall
          have the unrestricted right to use and disclose the Submitted Materials for any purpose
          without notice, attribution, compensation or obligation to any party. By providing any
          Submitted Materials, you agree and represent that such idea or suggestion is original and
          that you own all right, title and interest in and to the Submitted Materials. You agree
          and represent that any Submitted Materials do not violate the rights of any third parties,
          do not include any personally-identifying information relating to a third party and do not
          include any unlawful information or material. Your submission of any Submitted Materials
          constitutes your assignment to Company of all rights, title and interest in and to such
          Submitted Materials.
        </p>
        <p className={styles.contentSubtitle}>Monitoring and Enforcement; Termination</p>
        <p>
          You further understand and acknowledge that we have the right, but not the obligation, to
          remove, modify, or refuse to post any Submitted Materials in our sole discretion, and to
          take any action with respect to any Submitted Materials that we deem necessary or
          appropriate in our sole discretion, including disclosing Your identity or other
          information about You to any third party who claims that material posted by You violates
          their rights, and/or taking appropriate legal action, including, referral to law
          enforcement, if for any illegal use of the Website is suspected.
        </p>
        <p>
          We may terminate or suspend Your access to all or part of the Website without notice, for
          any or no reason, including without limitation, any violation of these Terms of Use.
        </p>
        <p>
          We do not undertake to review Submitted Material before it is posted on the Website, and
          cannot ensure prompt removal of objectionable material after it has been posted.
          Accordingly, we assume no liability for any action or inaction regarding transmissions,
          communications, or content provided by any user or third party. We have no liability or
          responsibility to anyone for performance or nonperformance of the activities described in
          this section.
        </p>
        <p className={styles.contentSubtitle}>Content Standards</p>
        <p>
          These Content Standards apply to any and all Submitted Materials. Submitted Materials must
          in their entirety comply with all applicable laws and regulations. Without limiting the
          foregoing, Submitted Materials must not:
          <ul>
            <li>
              contain any material that is defamatory, obscene, offensive, harassing, hateful, or
              otherwise objectionable;
            </li>
            <li>
              promote sexually explicit or pornographic material, violence, or discrimination based
              on race, sex, religion, nationality, disability, sexual orientation, or age;
            </li>
            <li>
              infringe any patent, trademark, trade secret, copyright, or other intellectual
              property or other rights of any other person;
            </li>
            <li>
              violate the legal rights (including the rights of publicity and privacy (see our{' '}
              {onlinePrivacyPolicyLink} and {consumerPrivacyNoticeLink})) of any person;
            </li>
            <li>promote or advocate any unlawful activity;</li>
            <li>
              impersonate anyone, or misrepresent Your identity or affiliation with any person or
              organization;
            </li>
            <li>involve commercial activities or sales,; or</li>
            <li>
              be deceptive or be posted for, or in connection with any spamming or other illicit
              activity.
            </li>
          </ul>
        </p>
        <p className={styles.contentSubtitle}>Copyright Agent – DMCA Notice</p>
        <p>
          Company respects the intellectual property rights of others. If you believe that any
          content on the Website infringes your copyright, please forward the following information
          to address identified below, pursuant to the Digital Millennium Copyright Act (DMCA), 17
          U.S.C. § 512(c)(2):
          <ul>
            <li> Your address, telephone number, and email address;</li>
            <li>A description of the copyrighted work that you claim has been infringed;</li>
            <li>A description of where the alleged infringing material is located;</li>
            <li>
              A statement by you that you have a good faith belief that the disputed use is not
              authorized by the copyright owner, its agent, or the law;
            </li>
            <li>
              An electronic or physical signature of the person authorized to act on behalf of the
              owner of the copyright interest; and
            </li>
            <li>
              A statement by you, made under penalty of perjury, that the above information in your
              notice is accurate and that you are the copyright owner or are authorized to act on
              the copyright owner’s behalf.
            </li>
          </ul>
        </p>
        <p>
          <p>Heights Finance Corporation</p>
          <p>Attention: Legal Department</p>
          <p>101 N. Main Street, #600 </p>
          <p>Greenville, SC 29601</p>
        </p>

        <p className={styles.contentSubtitle}>Geographic Restrictions</p>
        <p>
          We provide this Website for use only by persons located in the United States. We make no
          claims that the Website or any of its content is accessible or appropriate outside of the
          United States. Access to the Website may not be legal by certain persons or in certain
          countries. If you access the Website from outside the United States, you do so on your own
          initiative and are responsible for compliance with local laws.
        </p>
        <p className={styles.contentSubtitle}>
          Products and Services Subject to Acceptance By Company
        </p>
        <p>
          None of the products or services referenced on this Website shall constitute an offer to
          contract or an offer of credit. This Website may provide general information about the
          Company and its products and services. Information on the website does not constitute an
          offer to sell or a solicitation of any particular product or service. Some products and
          services may not be available in all states, and are not available outside the United
          States. Your eligibility for particular products and services is subject to final
          determination, restrictions and acceptance by the Company. Company makes no solicitation
          to any person in jurisdictions where the information, products or services provided
          through this Website are prohibited by law.
        </p>
        <p className={styles.contentSubtitle}>No Fiduciary Relationship</p>
        <p>
          YOU AGREE THAT NO CLIENT, ADVISORY, FIDUCIARY OR PROFESSIONAL RELATIONSHIP IS CREATED,
          IMPLIED OR ESTABLISHED BETWEEN YOU AND THE COMPANY BY USE OF THIS WEBSITE. YOU AGREE AND
          UNDERSTAND THAT IN CONNECTION WITH THIS WEBSITE, COMPANY IS NOT ENGAGED IN RENDERING
          AUDITING, ACCOUNTING, INVESTMENT, SECURITIES, TAX, LEGAL ADVICE AND THAT YOU WILL CONSULT
          APPROPRIATE LICENSED PROFESSIONALS FOR ADVICE RELATING TO THE SPECIFIC FACTS, LAWS AND
          ROLES WHICH MAY APPLY TO YOU.
        </p>
        <p className={styles.contentSubtitle}>Promotions</p>
        <p>
          Any and all offers or promotions advertised in this Website are void where prohibited, and
          are subject to the posting of any official rules pertaining to such offers or promotions.
        </p>
        <p className={styles.contentSubtitle}>Disclaimer of Warranties</p>
        <p>
          THE WEBSITE IS PROVIDED “AS IS” AND YOU AGREE THAT YOUR USE OF THE WEBSITE SHALL BE AT
          YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY, ITS OFFICERS,
          DIRECTORS, EMPLOYEES, AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING
          BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR A
          PARTICULAR PURPOSE, IN CONNECTION WITH THE WEBSITE AND YOUR USE THEREOF. WE MAKE NO
          WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THIS SITE’S CONTENT OR
          THE CONTENT OF ANY SITES LINKED TO THIS SITE AND ASSUME NO LIABILITY OR RESPONSIBILITY FOR
          (I) ANY ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) ANY PERSONAL INJURY OR PROPERTY
          DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF OUR WEBSITE,
          (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
          INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (IV) ANY INTERRUPTION OR
          CESSATION OF TRANSMISSION TO OR FROM OUR WEBSITE, (V) ANY BUGS, VIRUSES, TROJAN HORSES, OR
          THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH OUR WEBSITE BY ANY THIRD PARTY, AND/OR
          (VI) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED
          AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE
          AVAILABLE VIA THE WEBSITE. THE COMPANY DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
          RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH
          THE WEBSITE OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND
          THE COMPANY WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
          TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE
          PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE
          YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.
        </p>
        <p className={styles.contentSubtitle}>Limitation on Liability</p>
        <p>
          IN NO EVENT SHALL THE COMPANY, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE TO
          YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES
          WHATSOEVER RESULTING FROM (I) ANY ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) ANY
          PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS
          TO AND USE OF OUR WEBSITE, (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS
          AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (IV)
          ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR WEBSITE, (V) ANY BUGS,
          VIRUSES, TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH OUR WEBSITE BY
          ANY THIRD PARTY, AND/OR (VI) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR
          DAMAGE OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF ANY CONTENT POSTED, EMAILED,
          TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE WEBSITE, WHETHER BASED ON WARRANTY,
          CONTRACT, TORT, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT THE COMPANY IS ADVISED OF
          THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE
          FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION.
        </p>
        <p>
          YOU SPECIFICALLY ACKNOWLEDGE THAT THE COMPANY SHALL NOT BE LIABLE FOR ANY USER SUBMISSIONS
          OR COMMENTS, OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY AND THAT
          THE RISK OF HARM OR DAMAGE FROM THE FOREGOING RESTS ENTIRELY WITH YOU.
        </p>
        <p>
          The Website is controlled and offered by the Company from its facilities in the United
          States of America. The Company makes no representations that the Website is appropriate or
          available for use in other locations. Those who access or use the Website from other
          jurisdictions do so at their own volition and are responsible for compliance with local
          law.
        </p>
        <p className={styles.contentSubtitle}>Indemnification</p>
        <p>
          You agree to defend, indemnify and hold harmless the Company, its parent corporations,
          affiliates officers, directors, employees and agents, from and against any and all claims,
          damages, obligations, losses, liabilities, costs or debt, and expenses (including but not
          limited to attorney’s fees) arising from:
          <ul>
            <li>Your use of and access to the Website;</li>
            <li>Your violation of any term of these Terms of Use;</li>
            <li>
              Your violation of any third party right, including without limitation any copyright,
              property, or privacy right.
            </li>
          </ul>
        </p>
        <p>
          This defense and indemnification obligation will survive these Terms of Use and your use
          of the Website.
        </p>
        <p className={styles.contentSubtitle}>Waiver and Severability</p>
        <p>
          No waiver of these Terms of Use by the Company shall be deemed a further or continuing
          waiver of such term or condition or any other term or condition, and any failure of the
          Company to assert a right or provision under these Terms of Use shall not constitute a
          waiver of such right or provision.
        </p>
        <p>
          If any provision of these Terms of Use is held by a court of competent jurisdiction to be
          invalid, illegal or unenforceable for any reason, such provision shall be eliminated or
          limited to the minimum extent such that the remaining provisions of the Terms of Use will
          continue in full force and effect.
        </p>
        <p className={styles.contentSubtitle}>Ability to Accept Terms of Use</p>
        <p>
          You affirm that you are either more than 18 years of age, or an emancipated minor, or
          possess legal parental or guardian consent, and are fully able and competent to enter into
          the terms, conditions, obligations, affirmations, representations, and warranties set
          forth in these Terms of Use, and to abide by and comply with these Terms of Use. In any
          case, you affirm that you are over the age of 13, as the Website is not intended for
          children under 13. The Website is not directed at children under the age of thirteen (13)
          and the Company does not knowingly collect personal information from any child under the
          age of thirteen (13) at the Website.
        </p>
        <p className={styles.contentSubtitle}>Changes to the Terms of Use</p>
        <p>
          We reserve the right, from time to time, with or without notice to you, to change these
          Terms of Use in our sole and absolute discretion. The most current version of these Terms
          of Use can be reviewed by clicking on “Terms of Use” on the Policies & Disclosures page of
          the Website. The most current version of the Terms of Use will supersede all previous
          versions. Your use of the Website after changes are made means that you agree to be bound
          by such changes.
        </p>
        <p className={styles.contentSubtitle}>
          Governing Law, Jurisdiction & Limitation on Time to File Claims
        </p>
        <p>
          All matters relating to the these Terms of Use and any dispute or claim arising therefrom
          or related thereto shall be governed by and construed in accordance with the internal laws
          of the State of South Carolina without giving effect to any choice or conflict of law
          provision or rule (whether of the State of South Carolina or any other jurisdiction). Any
          legal suit, action or proceeding arising out of, or related to, these Terms of Use shall
          be instituted exclusively in the federal courts of the United States or the courts of the
          State of South Carolina in the County of Greenville County. You waive any and all
          objections to the exercise of jurisdiction over you by such courts and to venue in such
          courts.
        </p>
        <p>
          ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO THESE TERMS OF USE
          MUST BE COMMENCED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH
          CAUSE OF ACTION OR CLAIM IS PERMANENTLY BARRED.
        </p>
        <p className={styles.contentSubtitle}>Entire Agreement</p>
        <p>
          These Terms of Use constitutes the sole and entire agreement between you and Heights
          Finance Corporation and its affiliates, with respect to the Website and supersede all
          prior and contemporaneous understandings, agreements, representations and warranties, both
          written and oral, with respect to the Website. These Terms of Use, and any rights and
          licenses granted hereunder, may not be transferred or assigned by you, but may be assigned
          by the Company without restriction.
        </p>
        <p> Questions or comments regarding these Terms of Use can be sent to:</p>
        <p>
          <p>Heights Finance Corporation</p>
          <p>Attention: Legal Department</p>
          <p>101 N. Main Street, #600 </p>
          <p>Greenville, SC 29601</p>
        </p>
      </div>
    );
  };

  return <ContentWithBackButton title="Terms of Use">{renderContent()}</ContentWithBackButton>;
};

export default TermsOfUse;
